// extracted by mini-css-extract-plugin
module.exports = {"fileInput":"New_fileInput__3mftd","loadingIcon":"New_loadingIcon__r7JSr","menu":"New_menu__3bW-W"};